// extracted by mini-css-extract-plugin
var _1 = "tjs-data-catalog-tab__data--catalog-group tjs-_base__list-reset";
var _2 = "tjs-data-catalog-tab__data-catalog tjs-_base__list-reset tjs-_base__scrollbars";
var _3 = "tjs-data-catalog-tab__data-explorer tjs-tabs__tab-left-col";
var _4 = "tjs-data-catalog-tab__data-catalog tjs-_base__list-reset tjs-_base__scrollbars";
var _5 = "tjs-data-catalog-tab__data--catalog-group tjs-_base__list-reset";
var _6 = "tjs-data-catalog-tab__data-explorer tjs-tabs__tab-left-col";
var _7 = "tjs-data-catalog-tab__label tjs-_labels__label";
var _8 = "tjs-data-catalog-tab__root";
export { _1 as "data--catalog-group", _2 as "data-catalog", _3 as "data-explorer", _4 as "dataCatalog", _5 as "dataCatalogGroup", _6 as "dataExplorer", _7 as "label", _8 as "root" }
export default { "data--catalog-group": _1, "data-catalog": _2, "data-explorer": _3, "dataCatalog": _4, "dataCatalogGroup": _5, "dataExplorer": _6, "label": _7, "root": _8 }
